module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-tra-ab802598adcd9238c66686765a914b68.png";